import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export const RentalField = ({ field, form, onChange, ...props }) => {
  const { t } = useTranslation();
  return <div className="space-y-1.5 min-w-0"><Label htmlFor={`rental-${field}`}>{t(`rentalProperties.fields.${field}`)}{props.required ? ' *' : ''}</Label>
    <Input id={`rental-${field}`} data-testid={`rental-${field.replaceAll('_', '-')}-input`} value={form[field] ?? ''} onChange={event => onChange(field, event.target.value)} {...props} />
  </div>;
};

export const RentalSelect = ({ id, label, value, options, onChange, disabled }) => <div className="space-y-1.5 min-w-0"><Label htmlFor={id}>{label}</Label>
  <Select value={value} onValueChange={onChange} disabled={disabled}><SelectTrigger id={id} data-testid={id} className="min-w-0"><SelectValue /></SelectTrigger>
    <SelectContent data-testid={`${id}-menu`}>{options.map(option => <SelectItem key={option.value} value={option.value} data-testid={`${id}-${option.value}`}>{option.label}</SelectItem>)}</SelectContent>
  </Select>
</div>;